export default "__VITE_ASSET__WWjBhqU5__"